import { useCookies } from 'react-cookie'

import { type IntegrationServiceId } from './integrations'

const COOKIE_KEY = 'lastUsedDocumentConnector'
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export const useLastUsedDocumentConnector = (): [IntegrationServiceId | null, (serviceId: IntegrationServiceId) => void] => {
  const [cookies, setCookie] = useCookies([COOKIE_KEY])

  const recordLastUsedServiceId = (serviceId: IntegrationServiceId) => {
    setCookie(COOKIE_KEY, serviceId, { path: '/', maxAge: COOKIE_MAX_AGE })
  }

  return [(cookies[COOKIE_KEY] as IntegrationServiceId | undefined) ?? null, recordLastUsedServiceId]
}
